import AceEditor from "react-ace";
import React, { useEffect } from "react";
import { createStyles, makeStyles, Theme, useTheme } from "@material-ui/core";
import "brace/snippets/html";
import "brace/snippets/text";
import "brace/mode/text";
import "brace/ext/language_tools";
import * as ace from "brace";
import { Completer } from "./completer";
require("brace/theme/twilight");
require("brace/theme/tomorrow");

const langTools = ace.acequire("ace/ext/language_tools");

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    editor: {
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: theme.shape.borderRadius,
      marginTop: theme.spacing(1),
      width: "100%",
      minWidth: 450,
      backgroundColor: theme.palette.background.paper
    }
  })
);

export interface EditorProps {
  name: string;
  value: string;
  readOnly?: boolean;
  mode?: string;
  completer?: Completer;
  minLines?: number;
  editorStyle?: string;
  onChange?: (value: string, event?: any) => void;
  typeSafe?: boolean;
}

const EditorComponent = (props: EditorProps) => {
  const classes = useStyles();
  const theme = useTheme();
  const [inputValue, setInputValue] = React.useState();

  useEffect(() => {
    if (props.completer) {
      langTools.setCompleters([props.completer]);
    }
  }, []);

  useEffect(() => {
    if (props.typeSafe && typeof props.value != "string") {
      // @ts-ignore
      setInputValue(JSON.stringify(props.value, null, 2));
    } else {
      // @ts-ignore
      setInputValue(props.value);
    }
  }, [props.value]);

  const change = (value: any) => {
    if (props.onChange) {
      if (typeof value === "object") {
        props.onChange(JSON.stringify(value, null, 2));
        // @ts-ignore
        setInputValue(JSON.stringify(value, null, 2));
      } else {
        props.onChange(value);
        // @ts-ignore
        setInputValue(value);
      }
    }
  };

  const { minLines, readOnly, editorStyle, mode } = props;

  const configuration = {
    readOnly: readOnly,
    fontSize: "13px",
    showGutter: false,
    useWorker: true,
    enableSnippets: true,
    enableBasicAutocompletion: true,
    enableLiveAutocompletion: false,
    wrapBehavioursEnabled: true,
    maxLines: 40,
    minLines: minLines || 10,
    dragDelay: 500
  };

  return (
    <AceEditor
      width={"auto"}
      mode={mode || "text"}
      theme={theme.palette.type === "dark" ? "twilight" : "tomorrow"}
      className={editorStyle ? editorStyle : classes.editor}
      onChange={change}
      setOptions={configuration}
      editorProps={{ $blockScrolling: Infinity }}
      value={inputValue}
    />
  );
};

export const Editor = EditorComponent;
